export function getUserMedia(constraints) {
  if (navigator.mediaDevices && navigator.mediaDevices.getUserMedia) {
    return navigator.mediaDevices.getUserMedia(constraints);
  }

  return new Promise((resolve, reject) => {
    const getMedia = navigator.getUserMedia || navigator.webkitGetUserMedia;
    if (!getMedia) reject(new Error('Browser unsupported'));
    getMedia.call(navigator, constraints, resolve, reject);
  });
}

export const createObjectURL = (object) => {
  try {
    return window.URL.createObjectURL(object);
  } catch (e) {
    return null;
  }
};

export const revokeObjectURL = (url) => {
  try {
    return window.URL.revokeObjectURL(url);
  } catch (e) {
    return null;
  }
};

export const getBrowser = () => {
  let browser = 'none';
  if (window.navigator.userAgent.match('Firefox') !== null) {
    // Firefox
    browser = 'mozilla';
  } else if (window.navigator.userAgent.match('Chrome') !== null) {
    browser = 'chrome-stable';
    if (window.navigator.userAgent.match('Electron') !== null) {
      browser = 'electron';
    }
  } else if (window.navigator.userAgent.match('Safari') !== null) {
    browser = 'safari';
  } else if (window.navigator.userAgent.match('AppleWebKit') !== null) {
    browser = 'safari';
  }

  return browser;
};
